/*
 * @Author: freedeng
 * @Date: 2019-06-13 20:33:37
 * @Last Modified by: paddywu
 * @Last Modified time: 2019-11-23 11:52:59
 */
var ClientVarsHelper = /** @class */ (function () {
    function ClientVarsHelper() {
    }
    ClientVarsHelper.convertData2ClientVars = function (data) { };
    /**
     * 解包str 到clientVars数据
     * @param strData
     */
    ClientVarsHelper.unpackEjsData = function (strData) {
        var pos = 0;
        var data = strData || '';
        var end = data.length;
        var obj = {};
        while (pos < end) {
            var head = data.slice(pos, pos + 50).split('\n');
            if (head && head.length >= 3) {
                var key = head[0];
                var type = head[1];
                var lens = parseInt(head[2]);
                pos += head[0].length + head[1].length + head[2].length + 3;
                var value = data.slice(pos, pos + lens);
                pos += lens + 1;
                obj[key] = { type: type };
                if (type === 'json') {
                    obj[key].value = JSON.parse(value);
                }
                else {
                    obj[key].value = value;
                }
            }
            else {
                break;
            }
        }
        return obj;
    };
    ClientVarsHelper.updateClientVarsByEditPadInfo = function (clientVars, editPadInfo) {
        if (clientVars && clientVars.globalPadId === editPadInfo.padInfo.globalPadId) {
            if (editPadInfo.privilegeAttribute) {
                clientVars.privilegeAttribute = editPadInfo.privilegeAttribute;
            }
            if (editPadInfo.advPolicy) {
                clientVars.advPolicy = editPadInfo.advPolicy;
            }
            if (editPadInfo.title) {
                clientVars.padTitle = editPadInfo.title;
            }
        }
    };
    return ClientVarsHelper;
}());
export default ClientVarsHelper;
export { ClientVarsHelper };
//# sourceMappingURL=ClientVarsHelper.js.map